import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DoNotTouchIcon(props: IconProps) {
    return <Icon {...props} iconKey={"do_not_touch"}/>
}
